import React from 'react';
import Row from '../../../../../components/tag/Row';
import Span from '../../../../../components/tag/Span';
import OTButtonGroup from '../../../../../components/tag/OTButtonGroup';
import OTButton from '../../../../../components/tag/OTButton';
import { FormattedMessage } from 'react-intl';

let { id: module_id } = module;

const SetCloseContactModalContent = ({ name, setCloseContact, closeModal }) => {
  return (
    <Row>
      <h4 className={'ot-modal__title'}>
        <FormattedMessage id={`${module_id}.title`} values={{ name }} />
      </h4>
      <p>
        <FormattedMessage id={`${module_id}.content`} />
      </p>
      <Row style={{ textAlign: 'center' }}>
        <Span>
          <OTButtonGroup
            fullWidth={true}
            type="big"
            expectedCount="1"
            collapseOnMobile
          >
            <OTButton
              message={'cancel'}
              color={'gray'}
              onClick={() => {
                closeModal();
              }}
            />
            <OTButton
              message={'OK'}
              color={'darkBlue'}
              onClick={() => {
                setCloseContact();
                closeModal();
              }}
            />
          </OTButtonGroup>
        </Span>
      </Row>
    </Row>
  );
};

export default SetCloseContactModalContent;
